<template>
  <span
    v-on="$listeners"
    class="rating-badge"
    :class="[
      classname,
      { condensed, loved, liked, 'not-liked': notLiked, opaque },
    ]"
  >
    <AppIcon v-if="icon" :src="icon" />

    <slot v-if="$slots.default" />
    <span v-else-if="label" v-html="label"></span>
  </span>
</template>

<script>
import {
  COMPANY_RATING_OPTIONS,
  COMPANY_RATING_OPTION_LOVED,
  COMPANY_RATING_OPTION_LIKED,
  COMPANY_RATING_OPTION_NOT_LIKED,
} from '@/constants'
import AppIcon from '@/components/App/Icon.vue'

export default {
  name: 'CompanyRatingBadge',

  components: {
    AppIcon,
  },

  props: {
    option: {
      type: Number,
      required: false,
    },

    condensed: {
      type: Boolean,
      required: false,
      default: false,
    },

    loved: {
      type: Boolean,
      required: false,
      default: false,
    },

    liked: {
      type: Boolean,
      required: false,
      default: false,
    },

    notLiked: {
      type: Boolean,
      required: false,
      default: false,
    },

    opaque: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ratingOption() {
      const { loved, liked, notLiked } = this

      let { option } = this

      if (!option) {
        if (loved) option = COMPANY_RATING_OPTION_LOVED
        else if (liked) option = COMPANY_RATING_OPTION_LIKED
        else if (notLiked) option = COMPANY_RATING_OPTION_NOT_LIKED
      }

      const ratingOption = COMPANY_RATING_OPTIONS[option]

      return ratingOption
    },

    icon() {
      return this.$attrs?.icon ?? this.ratingOption?.icon
    },

    classname() {
      return this.ratingOption?.classname
    },

    label() {
      return this.$attrs?.label ?? this.ratingOption?.label
    },
  },
}
</script>

<style lang="scss" scoped>
.rating-badge {
  display: inline-flex;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 1rem;
  text-transform: uppercase;
  color: var(--Tokens-Neutral-neutral-shade, #1a1a1a);
  text-align: center;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1;

  &.condensed {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  &.loved {
    background-color: #cbfb01;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.5);
  }

  &.liked {
    background-color: var(--Tokens-Sucess-success-main, #2de36a);
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.5);
  }

  &.not-liked {
    background-color: var(--Tokens-Primary-primary-strawberry, #ff6a5c);
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.5);
  }

  &.opaque {
    opacity: 0.5;
  }
}
</style>
